import { component, getter, prop } from '../../decorators';


import CartMenuItem from '../cart-menu-item/cart-menu-item.vue';
import ProfileMenuItem from '../profile-menu-item/profile-menu-item.vue';

@component({
   name: 'Header',
   components: { CartMenuItem, ProfileMenuItem }
})
export default class Header {
   @prop({ type: Boolean, default: () => true }) showTitle

   @getter() getCurrentShowPict

   @getter() getCurrentShow

   showApps = false;
   hoverApps = false;

   get isLoadedShow() {
      return !!this.getCurrentShow;
   }

   get getCurrentShowName() {
      const show = this.getCurrentShow;
      return show ? show.name : '';
   }

   get appsVisible() {
      const user = this.$store.getters.getCurrentUser;
      return user.roles.some(r => r === 'admin' || r === 'manager');
   }

   appsBlur() {
      if (!this.hoverApps) { this.showApps = false; }
   }
}
